import React from 'react';

class OverWindow extends React.Component {
  static defaultProps = {
    clickOnCancel: () => {
      alert('Define prop: clickOnCancel');
    },
    title: 'Default Title',
    idPill: null,
    headerAction: null,
    showMenuIcon: false,
    children: <div className='border bg-warning'>This is the content.</div>,
    closeOnClickOutside: true,
    iconName: 'fa-solid fa-window-maximize',
    verticalScroll: true,
    maxWidth: 0,
    minHeight: 0,
    className: 'top-of-boxFigma',
  };

  constructor(props) {
    super(props);
    this.windowref = React.createRef();
    this.actionsToggleRef = React.createRef();
    this.state = { actionsOpen: false, menuTop: 68, hasActions: false, headClusterWidth: 0 };

    this.escFunction = this.escFunction.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
    this.toggleActions = this.toggleActions.bind(this);
    this.handleDocumentClick = this.handleDocumentClick.bind(this);
    this.updateHasActions = this.updateHasActions.bind(this);
  }

  componentDidMount() {
    document.addEventListener('keydown', this.escFunction, false);
    document.addEventListener('click', this.handleDocumentClick, false);
    if (this.props.closeOnClickOutside) {
      document.addEventListener('mousedown', this.handleClickOutside, false);
    }
    this.updateHasActions();
    // The action row comes and goes with the active content tab — watch the
    // popup's subtree so the "…" toggle tracks it (the state guard in
    // updateHasActions keeps this from looping on our own re-renders).
    if (this.windowref.current && typeof MutationObserver !== 'undefined') {
      this.actionsObserver = new MutationObserver(this.updateHasActions);
      this.actionsObserver.observe(this.windowref.current, { childList: true, subtree: true });
    }
  }

  componentWillUnmount() {
    document.removeEventListener('keydown', this.escFunction, false);
    document.removeEventListener('click', this.handleDocumentClick, false);
    if (this.props.closeOnClickOutside) {
      document.removeEventListener('mousedown', this.handleClickOutside, false);
    }
    if (this.actionsObserver) {
      this.actionsObserver.disconnect();
    }
  }

  // The mobile "…" toggle must appear only when THIS popup's content contains an
  // action row. A CSS :has() gate can't do this: a nested detail popup (e.g. a
  // Service opened from an Opportunity's Services tab) is a DOM descendant of the
  // outer popup, so the outer popup's row lit up the nested popup's toggle too.
  // Instead, count only rows whose nearest popup root is this window.
  updateHasActions() {
    const root = this.windowref.current;
    if (!root) return;
    const rows = root.querySelectorAll('.InnerMenuButtonFigmaList');
    const hasActions = Array.prototype.some.call(rows, (el) => el.closest('.top-of-boxFigma') === root);
    // The content action row is absolute-positioned into the header, left of the
    // pill/edit/close cluster. The cluster's width varies with the id-pill text (a
    // Lookup's pill is its NAME) and an optional edit action, so a fixed right offset
    // overlaps long pills. Measure the cluster and hand it to CSS via --ow-head-cluster
    // on the popup root (same pattern as --ow-menu-top). The MutationObserver re-runs
    // this when the header content changes (e.g. the pill fills in after data load).
    const cluster = root.querySelector('.OverWindowHeaderbutton');
    const headClusterWidth = cluster ? Math.ceil(cluster.getBoundingClientRect().width) : 0;
    if (hasActions !== this.state.hasActions || headClusterWidth !== this.state.headClusterWidth) {
      this.setState((prev) => ({
        hasActions,
        headClusterWidth,
        actionsOpen: hasActions ? prev.actionsOpen : false,
      }));
    }
  }

  // Mobile action-row dropdown (CD-5241): the header "…" toggle reveals the content
  // tab's .InnerMenuButtonFigmaList as a menu hanging from the toggle itself. Anchor
  // to the toggle's bottom edge, not the header height — a wrapped title makes the
  // header much taller than the top-pinned action buttons, which would strand the
  // menu far below the "…". Measured at open time and passed to CSS via the
  // --ow-menu-top custom property on the popup root.
  toggleActions() {
    const toggle = this.actionsToggleRef.current;
    const root = this.windowref.current;
    this.setState((prev) => ({
      actionsOpen: !prev.actionsOpen,
      menuTop: toggle && root ? toggle.getBoundingClientRect().bottom - root.getBoundingClientRect().top : prev.menuTop,
    }));
  }

  // Any click outside the toggle closes the dropdown — including clicks on the
  // action buttons themselves (their own handlers fire first via React's root
  // listener, this document-level listener runs after).
  handleDocumentClick(event) {
    if (!this.state.actionsOpen) return;
    const toggle = this.actionsToggleRef.current;
    if (toggle && toggle.contains(event.target)) return;
    this.setState({ actionsOpen: false });
  }

  escFunction(event) {
    if (event.keyCode === 27 && this.props.clickOnCancel) {
      this.props.clickOnCancel();
    }
  }

  handleClickOutside(event) {
    if (this.props.closeOnClickOutside) {
      const node = this.windowref.current;

      if (event.target.contains(node)) {
        event.preventDefault();
        if (this.props.clickOnCancel) {
          this.props.clickOnCancel();
        }
      }
    }
  }

  render() {
    const style =
      this.props.maxWidth === 0
        ? {}
        : {
            maxWidth: `${this.props.maxWidth}px`,
            margin: 'auto',
            //left: `calc(50% - ${this.props.maxWidth / 2}px)`,
          };

    if (this.props.minHeight !== 0) style.minHeight = `${this.props.minHeight}px`;
    if (this.state.actionsOpen) style['--ow-menu-top'] = `${this.state.menuTop}px`;
    if (this.state.headClusterWidth) style['--ow-head-cluster'] = `${this.state.headClusterWidth}px`;

    return (
      <div className='cent'>
        <div className='disable-outside-clicks'>
          <div
            className={`${this.props.className}${this.state.actionsOpen ? ' ow-actions-open' : ''}`}
            ref={this.windowref}
            style={style}
          >
            <div className='OverWindowWrapper '>
              {this.props.showMenuIcon && (
                <span className='OverWindowMenuIcon'>
                  <span />
                  <span />
                </span>
              )}
              <h6 className='OverWindowTitle'>
                <p>{this.props.title}</p>
              </h6>
              <div className='OverWindowHeaderbutton'>
                {this.props.idPill !== null && this.props.idPill !== undefined && this.props.idPill !== '' && (
                  <span className='ow-id-pill'>
                    <i className='fa-solid fa-table-columns' />
                    {this.props.idPill}
                  </span>
                )}
                {this.props.headerAction && (
                  <button
                    type='button'
                    className='ow-edit'
                    title={this.props.headerAction.label}
                    onClick={this.props.headerAction.onClick}
                  >
                    <i className={this.props.headerAction.iconName || 'fa-solid fa-pen'} />
                    <span>{this.props.headerAction.label}</span>
                  </button>
                )}
                {this.state.hasActions && (
                  <button
                    type='button'
                    className='ow-actions-toggle'
                    title='Actions'
                    ref={this.actionsToggleRef}
                    onClick={this.toggleActions}
                  >
                    <i className='fa-solid fa-ellipsis-vertical' />
                  </button>
                )}
                {this.props.clickOnCancel && (
                  <button
                    type='button'
                    className='ow-close'
                    onClick={() => {
                      if (this.props.clickOnCancel) {
                        this.props.clickOnCancel();
                      }
                    }}
                  >
                    <i className='fa-solid fa-xmark' />
                  </button>
                )}
              </div>
            </div>
            <div className={this.props.verticalScroll ? ' verticalScroll' : ''}>{this.props.children}</div>
          </div>
        </div>
      </div>
    );
  }
}

export default OverWindow;
